// extracted by mini-css-extract-plugin
export default {"img":"RahV7","description":"JvSIq","action":"IXdix","action--with-full-width":"Wqzd6","reject-wrapper":"pqC4o"};